export enum GaTrackingEventLabel {
  PriceTypeChangeToB2B = 'Show B2B price',
  PriceTypeChangeToB2C = 'Show B2C price',
  AboutUs = 'About us',
  Careers = 'Careers',
  OrderInfo = 'About my order',
  ShippingInfo = 'Delivery & tracking',
  BuyerReturnPolicy = 'Returns & refunds',
  ContactBuyer = 'Help-buyer',
  ContactSeller = 'Help-seller',
  FAQ = 'FAQ',
  SellerStartSelling = 'Sell on metro.de',
  SellerMakroStartSelling = 'Sell on makro.es',
  SellerMetroITStartSelling = 'Sell on metro.it',
  BuyerSupport = 'Buyer support',
  DiscountCode = 'Discount code conditions',
  Offers = 'Current METRO offers',
  SeeAll = 'See All',
  Left = 'Left',
  Right = 'Right',
  LeftArrowClick = 'left arrow clicked',
  RightArrowClick = 'right arrow clicked',
  PDPBuyboxQuantityPickerInteractionInline = 'PDP - inline',
  PDPBuyboxQuantityPickerInteractionButton = 'PDP - quantity picker  (+/-)',
  PDPBuyboxQuantityPickerInteractionVolumePrice = 'PDP - volume pricing',
  ImageZoomClick = 'image zoom clicked',
  HighlightsExpanded = 'Highlights expanded',
  HighlightsCollapsed = 'Highlights collapsed',
  ProductDescriptionExpanded = 'Product description expanded',
  ProductDescriptionCollapsed = 'Product description collapsed',
  ManufacturerInfoExpanded = 'Manufacturer information expanded',
  ManufacturerInfoCollapsed = 'Manufacturer information collapsed',
  GlobalFooterLinkImprint = 'imprint',
  conditionOfSale = 'Condition of sale',
  registrationPrivacyPolicy = 'Registration privacy policy',
  GlobalFooterLinkTermsOfUseAndPurchase = 'terms-of-use-and-purchase',
  GlobalFooterLinkPrivacyPolicy = 'privacy-policy',
  GlobalFooterLinkCookies = 'cookies',
  GlobalFooterLinkDisposalAndEnvironmentalRegulations = 'disposal-and-environmental-regulations',
  LogoutClick = 'logout click',
  TopBanners = 'Top Banners',
  TopAngebote = 'Top Angebote',
  SuggestedPromotionPage = 'suggested promotion page',
  SuggestedCategory = 'suggested category',
  SearchHistory = 'search history',
  SuggestedProduct = 'suggested product',
  SuggestedKeyword = 'suggested keyword',
  BounceOfBar = 'bounce of bar',
  ClickInTheBar = 'click in the bar',
  ExpiredPromoTag = 'Expired Promo Tag',
  HomePage = 'Home Page',
  CategoryGrid = 'Category Grid',
  Footer = 'Footer',
  ProductHighlights = 'Product Highlights',
  ProductDescription = 'Product Description',
  PromoView = 'Content Carousel shown',
  ManufacturerInformation = 'Manufacturer Information',
  BuyBox = 'Buy Box',
  PDPCarouselShown = 'PDP Carousel shown',
  VolumePriceTableSelected = 'selected quantity',
  PdpBrandInteraction = 'Brand name ({brand}) clicked',
  PdpSellerInteraction = 'Seller name ({seller}) clicked',
  ProductPage = 'Product page',
  CategoryPage = 'Category page',
  CartPage = 'Cart page',
  UserOrdersPage = 'User Orders Page',
  UserAccountInformationPage = 'User Account Information Page',
  UserAddressBookPage = 'User Address Book Page',
  LeftSwipe = 'left swipe',
  RightSwipe = 'right swipe',
  OrderHistoryClick = 'Order history click',
  Granted = 'granted',
  True = 'true',
  PDPRegisterAsBusinessClicked = 'Register as a business clicked',
  FromMiniCart = 'from mini cart',
  HoveringOver = 'hovering over',
  MagicLoginLinkExpired = 'Magic Login Link expired',
  CartMergeAlertTitle = 'Cart merge',
  AccountPendingActivation = 'Customer account is pending activation',
  ExpiredOffersLabel = 'Cart with expired offers',
  B2BOffersLabel = 'Cart with b2b offers',
  ReviewOrderEditCart = 'Review Order - User goes back to cart',
  CartItemRemoved = 'Item removed',
  ComplaintBook = 'ComplaintBook',
  ValueAddedServiceAlert = 'ValueAddedServiceAlert',
  BuyAgainBuyboxQuantityPickerInteractionInline = 'BAP - inline',
  BuyAgainBuyboxQuantityPickerInteractionButton = 'BAP - quantity picker (+/-)',
  OfferPriceHasChanged = 'Offer price has changed',
  VASRemoved = 'Value added service removed',
  VASQuantityHasChanged = 'Value added service quantity has changed',
  SearchZeroResultsPage = 'Zero Results Page',
  VATIdInvalidOnVies = 'VAT ID invalid on VIES',
  YourAssortmentQuantityPickerInteractionInline = 'SL - inline',
  YourAssortmentBuyboxQuantityPickerInteractionButton = 'SL - quantity picker (+/-)',
}
